import consumptionData from '../data/consumption.json'

export default {
    data() {
        return {
            AIR_DENSITY: 0.6125,
            GRAVITY: 9.807,
            JOULES_TO_KWH: 0.00000028,
            EARTH_RADIUS: 6371 * 1000,
            consumption: consumptionData,
            defaultConsumption: 6.350864,
            colours: ["#F4CC70", "#DE7A22", "#20948B", "#6AB187"]
        };
    },
    methods: {
        convexHull(points) {
            points.sort(function (a, b) {
                return a[0] != b[0] ? a[0] - b[0] : a[1] - b[1];
            });
    
            var n = points.length;
            var hull = [];
    
            for (var i = 0; i < 2 * n; i++) {
                var j = i < n ? i : 2 * n - 1 - i;
                while (hull.length >= 2 && this.removeMiddle(hull[hull.length - 2], hull[hull.length - 1], points[j]))
                    hull.pop();
                hull.push(points[j]);
            }
    
            hull.pop();
            return hull;
        },
        removeMiddle(a, b, c) {
            var cross = (a[0] - b[0]) * (c[1] - b[1]) - (a[1] - b[1]) * (c[0] - b[0]);
            var dot = (a[0] - b[0]) * (c[0] - b[0]) + (a[1] - b[1]) * (c[1] - b[1]);
            return cross < 0 || cross == 0 && dot <= 0;
        },
        colourForTrip(id) {
            return this.colours[id % this.colours.length]
        },
        colourForConsumption(e) {
            let index = e* 2.55;
            let r = index ;
            let g = (255 - index);
            let b = 0;
            return "#" + ((1<<24) + (r <<16) + (g << 8) + b).toString(16).slice(1);
        },
        toDegrees(val) {
            return val * (180 / Math.PI);
        },

        toRadians(val) {
            return val * (Math.PI / 180);
        },
        getConsumption(latlng) {
            if (latlng == null) {
                return this.defaultConsumption;
            }
            var lt = this.roundHalf(latlng.lat);
            var ln = this.roundHalf(latlng.lng);
            var c = this.consumption.find(x => x.lat == lt && x.lng == ln);
            if (c == null) {
                return this.defaultConsumption;
            }
            return c.km_kwh;
        },
        roundHalf(num) {
            return Math.round(num * 2) / 2;
        },
        calculateRange(car, latlng) {
            var consumption = this.getConsumption(latlng) * car.ConsumptionRatio;
            return ((car.BatterySize * car.SoH * 0.85) * consumption);

        },
        calculateKmPerKwh(car, latlng) {
            var consumption = this.getConsumption(latlng) * car.ConsumptionRatio;
            return consumption;
        },
        niceTime(time, seconds=true) {
            return new Date(time * 1000).toISOString().substr(11, seconds ? 8: 5);
        },
        niceDuration(seconds) {
            let hours = ~~(seconds / 3600);
            let minutes = ~~((seconds % 3600) / 60);
            let output = "";
            if (hours > 0) {
                output += hours + " hour" +(hours > 1 ? "s" : "");
            }
            if (minutes > 0) {
                output += (hours > 0 ? " and " : "") + minutes + " minute" + (minutes > 1 ? "s" : "");
            }
            return output;
        },
        calculatePetrolCost(distance) {
            var litres = (distance / 100000) * 11.2;
            const PETROL_PRICE = 2.2;
            return (litres * PETROL_PRICE).toFixed(2);
        },

        calculateCarbonCost(distance) {
            var litres = (distance / 100000) * 11.2;
            const CO2KGS_PER_LITRE = 2.392;
            return (litres * CO2KGS_PER_LITRE).toFixed(2);
        },
        haversineDistance(coords1, coords2) {
            function toRad(x) {
                return x * Math.PI / 180;
            }

            var lon1 = coords1.lng;
            var lat1 = coords1.lat;

            var lon2 = coords2.lng;
            var lat2 = coords2.lat;

            var x1 = lat2 - lat1;
            var dLat = toRad(x1);
            var x2 = lon2 - lon1;
            var dLon = toRad(x2)
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = this.EARTH_RADIUS * c;

            return d;
        },
        latlngFromLocation(location) {
            if (location.Address != null) {
                return {
                    lat: location.Address.geometry.coordinates[1],
                    lng: location.Address.geometry.coordinates[0]
                }
            }
            return null;
        },
        getWaypointLocation(start) {
            console.log(start);
            let point = {}
            switch(start[0]) {
                case "Address":
                    point.lat = start[1].latitude;
                    point.lng = start[1].longitude;
                    break;
                case "Station":
                    point.lat = start[1].Latitude;
                    point.lng = start[1].Longitude;
                    break;
            }
            return point;
        },
        getTripLocation(trip) {
            console.log(trip);
            let waypointData = JSON.parse(trip.WaypointData);
            let start = waypointData[0];
            return this.getWaypointLocation(start)
        }
    }
};






